import * as React from 'react';

const Reconciliation24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M19.5264 8.41797C19.8209 8.17775 20.2557 8.19516 20.5303 8.46973L23.5303 11.4697C23.8231 11.7626 23.823 12.2374 23.5303 12.5303C23.2374 12.8231 22.7626 12.8231 22.4697 12.5303L20.6553 10.7158C20.717 11.1353 20.75 11.564 20.75 12C20.75 16.8324 16.8324 20.7499 12 20.75C9.78146 20.75 7.75393 19.9235 6.21191 18.5625C5.90136 18.2884 5.87239 17.8145 6.14648 17.5039C6.42061 17.1935 6.89459 17.1635 7.20508 17.4375C8.48356 18.5658 10.1609 19.25 12 19.25C16.004 19.2499 19.25 16.004 19.25 12C19.25 11.6243 19.218 11.2561 19.1631 10.8965L17.5303 12.5303C17.2374 12.8231 16.7626 12.8231 16.4697 12.5303C16.1768 12.2374 16.1768 11.7626 16.4697 11.4697L19.4697 8.46973L19.5264 8.41797ZM12 3.25C14.2185 3.25004 16.2461 4.07653 17.7881 5.4375C18.0985 5.71158 18.1275 6.18557 17.8535 6.49609C17.5794 6.80652 17.1054 6.83648 16.7949 6.5625C15.5165 5.43418 13.8391 4.75004 12 4.75C7.99594 4.75 4.75001 7.99594 4.75 12C4.75 12.3758 4.77902 12.7446 4.83398 13.1045L6.46973 11.4697C6.76263 11.1769 7.23741 11.1769 7.53027 11.4697C7.82306 11.7626 7.82305 12.2374 7.53027 12.5303L4.53027 15.5303C4.23741 15.8231 3.76263 15.8231 3.46973 15.5303L0.469727 12.5303C0.176833 12.2374 0.176833 11.7626 0.469727 11.4697C0.762627 11.1769 1.23741 11.1769 1.53027 11.4697L3.34473 13.2842C3.28298 12.8647 3.25 12.436 3.25 12C3.25001 7.16751 7.16751 3.25 12 3.25Z'
				fill='black'
			/>
		</svg>
	);
};

export default Reconciliation24;
